import { compose } from "redux";
import { withRouter } from "react-router";

import withCurrentUser from "lib/containers/withCurrentUser";

import component from "./index.component";
import container from "./index.container";
import wrapper from "./index.wrapper";

export default compose(
  withRouter,
  withCurrentUser,
  container,
  wrapper
)(component);
